
export default function thousands(e){
   return getInputValue(e)
}
  // 金额添加千分位
  const comdify = function (n) {
    if(!n) return n;
    let str = n.split('.');
    let re = /\d{1,3}(?=(\d{3})+$)/g;
    let n1 = str[0].replace(re, "$&,");
    return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}`;
    };
    //去除千分位中的‘，'
    const delcommafy = function (num){
    if(!num) return num;
    num = num.toString();
    num = num.replace(/,/gi, '');
    return num;
    };
    // 获取输入框的值
    const getInputValue = function (el) {
    let inputVal = el || '';
    return comdify(delcommafy(inputVal));
    };